<mat-icon *ngIf="!disabled && !value" (click)="setOptions($event, true)" title="{{label}}" class="iconLabel">
    check_box_outline_blank</mat-icon>
<mat-icon *ngIf="!disabled && value" (click)="setOptions($event, false)" title="{{label}}" class="iconLabel">check_box
</mat-icon>
<mat-icon *ngIf="disabled" title="{{disabledLabel}}" class="iconLabel disabledIconLabel">
    check_box_outline_blank</mat-icon>
<label [class.disabledLabel]="disabled" title="{{disabledLabel}}">{{label}}</label>